module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "c3",
    attrs: {
      "id": "calibre_pb_3"
    }
  }, [_c('br', {
    staticClass: "calibre2"
  })]), _vm._v(" "), _c('p', {
    staticClass: "c"
  }, [_vm._v("The Inertia of Glue")]), _vm._v(" "), _c('p', {
    staticClass: "western1"
  }, [_c('br', {
    staticClass: "calibre2"
  })]), _vm._v(" "), _c('p', {
    staticClass: "western1"
  }, [_c('br', {
    staticClass: "calibre2"
  })]), _vm._v(" "), _c('p', {
    staticClass: "c6"
  }, [_vm._v("We prepare for what ever")]), _vm._v(" "), _c('p', {
    staticClass: "c6"
  }, [_vm._v("may come our way")]), _vm._v(" "), _c('p', {
    staticClass: "c6"
  }, [_vm._v("Hoping to survive just")]), _vm._v(" "), _c('p', {
    staticClass: "c6"
  }, [_vm._v("one more day.")]), _vm._v(" "), _c('p', {
    staticClass: "c6"
  }, [_c('br', {
    staticClass: "calibre2"
  })]), _vm._v(" "), _c('p', {
    staticClass: "c6"
  }, [_vm._v("We buy, can, do, get, until there's")]), _vm._v(" "), _c('p', {
    staticClass: "c6"
  }, [_vm._v("Room for no more")]), _vm._v(" "), _c('p', {
    staticClass: "c6"
  }, [_vm._v("And when the stress goes up,")]), _vm._v(" "), _c('p', {
    staticClass: "c6"
  }, [_vm._v("it's back to the store.")]), _vm._v(" "), _c('p', {
    staticClass: "c6"
  }, [_c('br', {
    staticClass: "calibre2"
  })]), _vm._v(" "), _c('p', {
    staticClass: "c6"
  }, [_vm._v("Swimming in glue -")]), _vm._v(" "), _c('p', {
    staticClass: "c6"
  }, [_vm._v("Can't move onward, but don't dare stop.")]), _vm._v(" "), _c('p', {
    staticClass: "c6"
  }, [_vm._v("Not going forward, but can't go back.")]), _vm._v(" "), _c('p', {
    staticClass: "c6"
  }, [_vm._v("(what did I forget? what do I lack?)")]), _vm._v(" "), _c('p', {
    staticClass: "c6"
  }, [_vm._v("Questions and doubts settle like a cool fog,")]), _vm._v(" "), _c('p', {
    staticClass: "c6"
  }, [_vm._v("tightening the grip.")]), _vm._v(" "), _c('p', {
    staticClass: "c6"
  }, [_c('br', {
    staticClass: "calibre2"
  })]), _vm._v(" "), _c('p', {
    staticClass: "c6"
  }, [_vm._v("Where do we go from here?")]), _vm._v(" "), _c('p', {
    staticClass: "c6"
  }, [_vm._v("What do we do now?")]), _vm._v(" "), _c('p', {
    staticClass: "c6"
  }, [_vm._v("The inertia of glue.")]), _vm._v(" "), _c('p', {
    staticClass: "c6"
  }, [_c('br', {
    staticClass: "calibre2"
  })]), _vm._v(" "), _c('p', {
    staticClass: "c6"
  }, [_vm._v("You prep")]), _vm._v(" "), _c('p', {
    staticClass: "c6"
  }, [_vm._v("You lay plans")]), _vm._v(" "), _c('p', {
    staticClass: "c6"
  }, [_vm._v("Never knowing if they're the right plans")]), _vm._v(" "), _c('p', {
    staticClass: "c6"
  }, [_vm._v("Because you want to never use them,")]), _vm._v(" "), _c('p', {
    staticClass: "c6"
  }, [_vm._v("or do you?")]), _vm._v(" "), _c('p', {
    staticClass: "c6"
  }, [_vm._v("We tell them...")]), _vm._v(" "), _c('p', {
    staticClass: "c6"
  }, [_vm._v("I'm prepared to be wrong ~")]), _vm._v(" "), _c('p', {
    staticClass: "c6"
  }, [_vm._v("Are you?")]), _vm._v(" "), _c('p', {
    staticClass: "c6"
  }, [_c('br', {
    staticClass: "calibre2"
  })]), _vm._v(" "), _c('p', {
    staticClass: "c6"
  }, [_vm._v("By Deborah D. Moore")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-28688508","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/tmp_648f5cba11b35594391da1bef1608eec_YkgYR9.ch.fixed.fc.tidied.stylehacked.xfixed_split_004.vue
// module id = 72
// module chunks = 0